import styled from "styled-components";
import { defaultBreakpoints } from "styled-media-query";

export const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  justify-items: center;
  min-height: 250px;
  margin-bottom: 20px;

  @media (max-width: ${defaultBreakpoints.large}) {
    min-height: 50px;
    margin-bottom: 0;
  }
  &.desktop_banner {
    @media (max-width: 754px) {
      display: none;
    }
  }
  &.mobile_banner {
    @media (min-width: 755px) {
      display: none;
    }
  }

  .topbar {
    margin: auto;
    display: flex;
    justify-self: center;
    justify-content: center;
    justify-items: center;
    @media (max-width: ${defaultBreakpoints.large}) {
      max-width: 100vw;
      overflow-x: hidden;
    }
  }
`;
